<template>
  <div class="transaction-calc-component">
    <v-row class="amount-field suggestions">
      <v-col sm="6">
        <v-text-field
          v-model.number="amount"
          hide-details="auto"
          class="text-field"
          type="number"
          :value="value"
          height="107px"
          flat
          solo
        />
      </v-col>
      <v-col sm="6">
        <div class="d-flex a-center">
          <div class="d-flex flex-column align-start">
            <v-btn
              class="button button-increase-amount"
              height="50px"
              :ripple="false"
              @click="increaseOneAmount"
            >
              <font-awesome-icon icon="chevron-up" color="#333333" />
            </v-btn>
            <v-btn
              class="button button-decrease-amount"
              height="50px"
              :ripple="false"
              @click="decreaseOneAmount"
            >
              <font-awesome-icon icon="chevron-down" color="#333333" />
            </v-btn>
          </div>
          <v-btn
            height="107px"
            class="button button-clear body-2 font-weight-medium"
            :ripple="false"
            @click="clearAmount"
          >
            <font-awesome-icon icon="times" class="mr-3" />
            ОЧИСТИТЬ
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <div v-if="currency === 'terminal'" class="checks-section" :class="{'checks-section-disabled': currency !== 'terminal'}">
      <transaction-checks
        v-if="currency === 'terminal'"
        v-model="computedChecks"
        :transaction="transaction"
      />
    </div>
    <v-row class="suggestions">
      <v-col v-for="(item, i) in amounts.slice(0, 4)" :key="i" sm="6">
        <v-badge
          class="fullwidth"
          :content="item.count"
          :color="item.count ? '#ff9100' : 'transparent'"
        >
          <v-btn class="button" block @click="setAmount(item.amount)">
            {{ item.amount | amountWithCurrency }}
          </v-btn>
        </v-badge>
      </v-col>
    </v-row>
    <v-row class="suggestions">
      <v-col v-for="(item, i) in amounts.slice(4, 7)" :key="i" sm="4">
        <v-badge
          class="fullwidth"
          :content="item.count"
          :color="item.count ? '#ff9100' : 'transparent'"
        >
          <v-btn class="button" block @click="setAmount(item.amount)">
            {{ item.amount | amountWithCurrency }}
          </v-btn>
        </v-badge>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import TransactionChecks from '../transaction-checks/TransactionChecks'

  export default {
    name: 'TransactionCalc',
    components: {
      TransactionChecks,
    },
    model: {
      prop: 'value',
      event: 'input',
    },
    props: {
      value: [String, Number],
      currency: {
        type: String,
        default: 'cash',
      },
      transaction: {
        type: Object,
        default: () => ({}),
      },
      checks: {
        type: Number,
        default: 0,
      },
      hideChecks: Boolean,
    },
    data () {
      return {
        tenCount: 0,
        amounts: [
          { amount: 5000, count: 0 },
          { amount: 2000, count: 0 },
          { amount: 1000, count: 0 },
          { amount: 500, count: 0 },
          { amount: 100, count: 0 },
          { amount: 50, count: 0 },
          { amount: 10, count: 0 },
        ],
      }
    },
    computed: {
      amount: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        },
      },
      computedChecks: {
        get () {
          return this.checks
        },
        set (value) {
          this.$emit('update:checks', value)
        },
      },
      isCourierTransaction () {
        return this.transaction.transitType === 'courier_transit'
      },
      isSendOperation () {
        return this.transaction.operationType === 'send'
      },
    },
    watch: {
      currency () {
        this.tenCount = 0
        this.setAmountFromTransaction()
        this.setChecksCountFromTransaction()
      },
    },
    created () {
      this.setAmountFromTransaction()
      this.setChecksCountFromTransaction()
    },
    methods: {
      setAmountFromTransaction () {
        if (this.isCourierTransaction && this.isSendOperation) {
          console.log('setAmountFromTransaction', this.currency)
          if (this.currency === 'terminal') {
            this.setAmount(this.transaction.fTerminalBefore)
          } else {
            this.setAmount(this.transaction.fCashBefore)
          }
        }
      },
      setChecksCountFromTransaction () {
        if (this.isCourierTransaction && this.isSendOperation && this.currency === 'terminal') {
          this.computedChecks = this.transaction.fChecksBefore
        }
      },
      increaseOneAmount () {
        let terminalChecksBalance = 0
        try {
          terminalChecksBalance = parseInt(this.transaction.senderBalance.terminalChecksBalance)
        } catch {
          return
        }

        if (
          this.transaction.operationType === 'send' &&
          this.currency === 'terminal' &&
          terminalChecksBalance < this.amount + 1
        ) return
        if (
          this.transaction.operationType === 'send' &&
          this.currency === 'cash' &&
          this.transaction.senderBalance.cashBalance < this.amount + 1
        ) return

        this.amount += 1
      },
      decreaseOneAmount () {
        let terminalChecksBalance = 0
        try {
          terminalChecksBalance = parseInt(this.transaction.senderBalance.terminalChecksBalance)
        } catch {
          return
        }

        if (
          this.transaction.operationType === 'send' &&
          this.currency === 'terminal' &&
          terminalChecksBalance < this.amount + 1
        ) return
        if (
          this.transaction.operationType === 'send' &&
          this.currency === 'cash' &&
          this.transaction.senderBalance.cashBalance < this.amount + 1
        ) return
        if (!this.amount) {
          return
        }
        this.amount -= 1
      },
      setAmount (amount) {
        if (
          this.transaction.operationType === 'send' &&
          this.currency === 'terminal' &&
          this.transaction.fTerminalBefore < parseInt(this.amount) + amount
        ) {
          amount = this.transaction.fTerminalBefore - this.amount
        }

        if (
          this.transaction.operationType === 'send' &&
          this.currency === 'cash' &&
          this.transaction.fCashBefore < parseInt(this.amount) + amount
        ) {
          amount = this.transaction.fCashBefore - this.amount
        }

        this.$nextTick(() => {
          if (this.amount) {
            this.amount = parseInt(this.amount)
          }
          this.amount += parseInt(amount)
          const currentAmount = this.amounts.find(item => item.amount === amount)
          if (currentAmount) {
            currentAmount.count++
          }
        })
      },
      clearAmount () {
        this.amount = 0
        this.tenCount = 0
        this.$nextTick(() => {
          this.amount = 0
          this.clearAmountCount()
        })
      },
      clearAmountCount () {
        this.amounts.forEach(item => {
          item.count = 0
        })
      },
    },
  }
</script>

<style lang="less" scoped>
  .transaction-calc-component {
    .checks-section-disabled {
      height: 96px;
    }

    .suggestions {
      margin-left: -6px;
      margin-right: -6px;
      .col {
        padding: 6px;
      }
    }

    .button-increase-amount {
      border-bottom-left-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
      margin-bottom: 7px;
    }

    .button-decrease-amount {
      border-top-left-radius: 0 !important;
      border-top-right-radius: 0 !important;
      margin-left: 0 !important;
    }

    .text-field {
      ::v-deep {
        .v-input__slot {
          border: 2px solid #ff9500 !important;
        }
      }

      &.error--text {
        ::v-deep {
          .v-input__slot {
            border: 2px solid @color-error;
          }
        }
      }

      ::v-deep {
        .v-input__slot {
          height: 80px;
          background-color: @color-secondary;
          border-radius: 15px;

          input {
            font-size: 25px;
            line-height: 18px;
          }
        }
      }
    }

    .button-badge {
      margin-left: 10px;
      &:first-child {
        margin-left: 0;
      }
    }

    .button-bump-amount {
      &:first-child {
        margin-left: 0;
      }
      svg {
        margin-left: 5px;
      }
    }

    .button {
      height: 80px;
      border-radius: 10px;
      font-size: 18px;
      background-color: @color-secondary !important;
      //box-shadow: 0 3px 6px #00000029 !important;

      &.button-clear {
        display: inline-flex;
        flex-grow: 1;
        margin-left: 10px;

        svg {
          width: 15px;
          height: 15px;
          .fill-svg(@color-error);
        }
      }

      &.button-apply {
        background-color: @color-primary !important;
      }
    }
  }
</style>
